import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles<Theme, { marginBottom?: number }>(theme => ({
  inputWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    marginBottom: ({ marginBottom }) => theme.spacing(marginBottom ?? 2),
    '& + &': {
      marginTop: theme.spacing(2)
    }
  }
}));

const InputFieldWrapper = ({
  children,
  className,
  marginBottom
}: {
  children: React.ReactNode;
  className?: string;
  marginBottom?: number;
}) => {
  const classes = useStyles({ marginBottom });

  return (
    <div className={clsx(classes.inputWrapper, className)}>{children}</div>
  );
};

export default InputFieldWrapper;
